module.exports = __webpack_public_path__ + "static/media/video-retraining-ja.beb26f61.vtt";